import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import LegalDocuments from '../features/LegalDocuments';

type Props = {
    setActiveRightTab?: Function;
};

export default function LegalDocumentsScreen({ setActiveRightTab }: Props) {
    return (
        <ScreenWrapper>
            <LegalDocuments setActiveRightTab={setActiveRightTab} />
        </ScreenWrapper>
    );
}
